import * as React from 'react';
import { MeatballMenu, PromptConfirmationModal } from 'ui';
import { ImportFileStatus } from 'app/area/import/types';
import styles from './import-view.scss';
import { Value } from 'app/types-shared';

export interface ImportContextMenuProps {
  id: number;
  importStatus: Value;
  translation: any;
  canEdit: boolean;
  handleEdit: (id: number) => void;
  handleRetry: () => void;
  handleDelete: () => void;
}

export const ImportContextMenu: React.SFC<ImportContextMenuProps> = (props: ImportContextMenuProps) => {
  const { id, importStatus, handleRetry, handleDelete, translation } = props;
  const handleEdit = () => props.handleEdit(id);

  return (
    <div className={styles.tileDropdown}>
      <MeatballMenu>
        <button type="button" className="dropdown-item" onClick={handleEdit} disabled={!props.canEdit}>
          {translation.import_edit_title}
        </button>
        <PromptConfirmationModal
          title={translation.import_delete_title}
          description={translation.import_delete_desc}
          continueText={translation.import_submit}
          cancelText={translation.import_cancel}
          onContinue={handleDelete}>
          <button type="button" className="dropdown-item">{translation.import_delete}</button>
        </PromptConfirmationModal>
        {importStatus && importStatus.v === ImportFileStatus.failed
          && <button type="button" className="dropdown-item" onClick={handleRetry}>{translation.import_retry}</button>}
      </MeatballMenu>
    </div>
  );
};
